
<script>
import Photo from './Photo.vue'

export default {
  functional: true,
  props: ['attributes'],
  render (h, {props}) {
    const {src, value, alt, caption, hasdesktop} = props.attributes
    const $photos = src.map((src, i) => h(Photo, {
      props: {
        attributes: {
          value: value + '/' + src,
          alt: (alt && alt[i]) || null,
          caption: (caption && caption[i]) || null,
          hasdesktop: hasdesktop || null
        }
      }
    }))
    return h('div', {
      class: {
        'photogrid-container': true,
        'maxColumn': src.length >= 3
      }
    }, $photos)
  }
}
</script>

<style lang="scss">
.component.component-photogrid .component-content {
  @include container;

  padding: 0;

  .photogrid-container {
    & > * {
      margin-bottom: 20px;

      &:last-of-type {
        margin-bottom: 0;
      }

      figcaption {
        padding-bottom: 0;
      }
    }

    @include breakpoint($d_medium) {
      @include grid_template(2);

      &.maxColumn {
        @include grid_template(3);
      }
    }
  }
}
</style>
